import {addClass, find, hasClass, listener} from "../../../../../modules/vegas/js/util";
import VGCatalogFilters from "./filters";
import {VGSidebar} from "vgsidebar";

document.addEventListener('DOMContentLoaded', onReady)

window.catalogFilter = null;

function getFilterInstance(selector) {
	selector = selector || '#catalog-filters';

	if (!window.catalogFilter) {
		window.catalogFilter = new VGCatalogFilters(document.querySelector(selector));
	}

	return window.catalogFilter;
}

function onReady() {
	let filter = getFilterInstance();
	filter.init();
	filter.setApplied();
	filter.select();
}

listener('vg.sidebar.loaded', '#sidebar-filters', (el, e) => {
	window.catalogFilter = null;
	let filter = getFilterInstance('#catalog-filters-mobile');
	filter.init();
	filter.setApplied();
	filter.select();
});

listener('click', '#sidebar-filters [data-vg-dismiss="sidebar"]', (el, e) => {
	VGSidebar.getInstance(el.closest('.vg-sidebar')).hide();
});


/** Ищут параметр **/
listener('keyup', '.catalog-filters--item [name=search-filter]', function (el, event) {
	getFilterInstance().search(el);
}, true);

/** Чекают параметр **/
listener('click', '[data-toggle=filter-check]', function (el, event) {
	addClass(el, 'shown');

	if (hasClass(el, 'radio')) {
		getFilterInstance().radio(el);
	} else {
		getFilterInstance().check(el);
	}
}, true);

/** Что там вводят в диапазоны **/
listener('keyup blur change', '.range-input', function (el, event) {
	getFilterInstance().range(el);
}, true);

/** Сбрасывают параметр **/
/*listener('click', '[data-dismiss="filter-applied"]', function (el, event) {
	let $set = find('.catalog-filters--item[data-param="' + el.id + '"]');
	if ($set) {
		getFilterInstance().reset($set);
	}
}, true);*/

/** Сбрасывают все параметр **/
listener('click', '[data-dismiss="filter-applied-all"]', function (el, event) {
	getFilterInstance().reset();
}, true);

/** Тыкнули на кнопку фильтровать **/
/*listener('click', '#btn-catalog-filter', function (el, event) {

}, true);*/
